(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brazilian-citizen', {
            parent: 'entity',
            url: '/brazilian-citizen?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'c3WebApp.brazilianCitizen.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brazilian-citizen/brazilian-citizens.html',
                    controller: 'BrazilianCitizenController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brazilianCitizen');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('brazilian-citizen-detail', {
            parent: 'brazilian-citizen',
            url: '/brazilian-citizen/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'c3WebApp.brazilianCitizen.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brazilian-citizen/brazilian-citizen-detail.html',
                    controller: 'BrazilianCitizenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brazilianCitizen');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BrazilianCitizen', function($stateParams, BrazilianCitizen) {
                    return BrazilianCitizen.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'brazilian-citizen',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('brazilian-citizen-detail.edit', {
            parent: 'brazilian-citizen-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brazilian-citizen/brazilian-citizen-dialog.html',
                    controller: 'BrazilianCitizenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrazilianCitizen', function(BrazilianCitizen) {
                            return BrazilianCitizen.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brazilian-citizen.new', {
            parent: 'brazilian-citizen',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brazilian-citizen/brazilian-citizen-dialog.html',
                    controller: 'BrazilianCitizenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brazilian-citizen', null, { reload: 'brazilian-citizen' });
                }, function() {
                    $state.go('brazilian-citizen');
                });
            }]
        })
        .state('brazilian-citizen.edit', {
            parent: 'brazilian-citizen',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brazilian-citizen/brazilian-citizen-dialog.html',
                    controller: 'BrazilianCitizenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrazilianCitizen', function(BrazilianCitizen) {
                            return BrazilianCitizen.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brazilian-citizen', null, { reload: 'brazilian-citizen' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brazilian-citizen.delete', {
            parent: 'brazilian-citizen',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brazilian-citizen/brazilian-citizen-delete-dialog.html',
                    controller: 'BrazilianCitizenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BrazilianCitizen', function(BrazilianCitizen) {
                            return BrazilianCitizen.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brazilian-citizen', null, { reload: 'brazilian-citizen' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
